// extracted by mini-css-extract-plugin
module.exports = {"Title":"installCenters_Title__7Nq6r","InstallCenters":"installCenters_InstallCenters__c7jx_","AdrBlock":"installCenters_AdrBlock__3djr8"};